<template>
  <div class="opretions d-flex flex-column flex-grow-1">
    <div
      class="selector-container d-flex section-container"
      :class="{ dark: skinType }"
    >
      <SectionTitle title="运维档案"></SectionTitle>
      <el-form
        :inline="true"
        ref="form"
        class="none-width flex-grow-1"
        :model="form"
        size="small"
        style="text-align: left"
      >
        <el-form-item
          label="项目"
          v-if="projectList"
          :class="{ 'light-label': skinType }"
        >
          <el-select
            class="form-item form-item-select"
            v-model="form.selectProjectId"
            placeholder="请选择"
            @change="changeProject"
          >
            <el-option
              v-for="(project, index) of projectList"
              :key="index"
              :label="project.ModelName"
              :value="project.IdStr"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期" :class="{ 'light-label': skinType }"
         >
          <el-date-picker
            class="form-item form-item-picker"
            style="width:220px;"
            v-model="form.selectPeriod"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="关键字" :class="{ 'light-label': skinType }">
          <el-input
            class="form-item form-item-input"
            v-model="form.keys"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="" type="primary" @click="onSubmit">查询</el-button>
          <el-button class="" @click="addNew">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      class="none-height flex-grow-1"
      style="width: 100%"
            stripe
      size="small"
      :class="{ dark: skinType }"
      :row-class-name="
        (...nu) => {
          return skinType ? 'dark text-white' : '';
        }
      "
    >
      <el-table-column label="#" type="index" width="60"> </el-table-column>
      <el-table-column prop="ReportDate" label="时间"> </el-table-column>
      <el-table-column prop="ReportName" label="报告名称"> </el-table-column>
      <el-table-column prop="StationName" label="所属配电室"></el-table-column>
      <el-table-column prop="ProjectName" label="所属项目"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleModify(scope.row)"
            >修改</el-button
          >
          <el-button
            size="mini"
            @click="handleDownload(scope.row)"
            >下载</el-button
          >
           <el-button
            size="mini"
            style="background-color: #F56C6C"
            @click="delbutton(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div
      class="d-flex section-container"
      style="padding: 1rem"
      :class="{ dark: skinType }"
    >
      <el-pagination
        v-if="pageInfo.total"
        style="margin-left: auto"
        background
        :class="{ 'text-white': skinType }"
        layout="total, prev, pager, next"
        :total="pageInfo.total"
        :current-page.sync="pageIndex"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="diaTitle"
      :visible.sync="dialogVisible"
      :class="{ dark: skinType }"
    >
      <el-form ref="postForm" :model="selectFormOps" label-width="120px">
        <el-form-item label="报告名称" :class="{ 'light-label': skinType }">
          <el-input v-model="selectFormOps.ReportName"></el-input>
        </el-form-item>
        <el-form-item
          v-if="projectList"
          label="所属项目"
          :class="{ 'light-label': skinType }"
          style="text-align: left"
        >
          <el-select
            class="form-item"
            v-model="selectFormOps.ProjectIDstr"
            placeholder="请选择项目"
          >
            <el-option
              v-for="(project, index) of projectList"
              :key="index"
              :label="project.ModelName"
              :value="project.IdStr"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          style="text-align: left"
          v-if="selectFormProject&&selectFormProject.Children"
          label="所属配电室"
          :class="{ 'light-label': skinType }"
        >
          <el-select
            class="form-item"
            v-model="selectFormOps.StationIDstr"
            placeholder="请选择配电室"
          >
            <el-option
              v-for="(room, index) of selectFormProject.Children"
              :key="index"
              :label="room.ModelName"
              :value="room.IdStr"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          style="text-align: left"
          label="报告日期"
          :class="{ 'light-label': skinType }"
        >
          <el-date-picker
            class="form-item"
            type="month"
            placeholder="选择日期"
            v-model="selectFormOps.ReportDate"
            format="yyyy-MM"
            value-format="yyyy-MM"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <el-button
            size="mini"
            style="margin-left: 1rem"
            @click="downloadBaseReport"
            :loading="isLoadingBaseReport"
            >下载基础报告</el-button
          >
        </el-form-item>
        <el-form-item
          label="附件"
          style="text-align: left"
          :class="{ 'light-label': skinType }"
        >
          <el-button
            v-if="selectOps.FilePath && !modifyFile"
            type=""
            v-on:click="modifyFile = true"
            >更改文件</el-button
          >
          <el-input
            v-else
            type="file"
            ref="fileInput"
            v-model="selectFormOps.FilePath"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="postForm">确认</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import SectionTitle from '@/components/utils/section-title.vue';
import { BASE_URL } from '@/utils/request/request';
import {
  getOpsFiles,
  addOpsFile,
  modifyOpsFile,
  delreport,
  getStationBaseReport,
} from '@/api/equipments/equipments';
import { formatDate, convertDataToFormData } from '@/utils/utils';

export default {
  name: 'reports',
  components: {
    SectionTitle,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      modifyFile: false,
      // 是否新报告
      isNew: false,
      diaTitle: '',
      form: {
        selectProjectId: null,
        keys: null,
        selectPeriod: [
          formatDate(new Date(), 'yyyy-MM-01'),
          formatDate(new Date(), 'yyyy-MM-dd'),
        ],
      },
      // 是否展示dialog
      dialogVisible: false,
      selectOps: {},
      selectFormOps: {},
      pageInfo: {
        index: 1,
        size: 10,
        total: 1,
      },
      pageIndex: 1,
      tableData: [],
      selectFormProject: null,
      selectFormRoom: null,
      isLoadingBaseReport: false,
    };
  },
  created() {
    this.requestProjectList();
  },
  watch: {
    pageIndex() {
      this.requestOpsFiles();
    },
    pageInfo: {
      deep: true,
      handler() {
        this.requestOpsFiles();
      },
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.modifyFile = false;
      }
    },
    projectList() {
      this.initialData();
    },
    selectProjectId(newVal) {
      this.selectProjectListener(newVal);
    },
    selectStationId(newVal) {
      this.selectRoomListener(newVal);
    },
  },
  computed: {
    projectList() {
      return this.$store.getters.projectList;
    },
    skinType() {
      return this.$store.getters.skinType;
    },
    selectProjectId() {
      return this.selectFormOps.ProjectIDstr;
    },
    selectStationId() {
      return this.selectFormOps.StationIDstr;
    },
  },
  methods: {
    changeProject(val) {
      this.$store.dispatch('projects/setSelectProject', val);
    },
    downloadBaseReport() {
      if (!this.selectFormOps.StationIDstr || !this.selectFormOps.ReportDate) {
        this.$message({
          type: 'warning',
          message: '请选择配电室和报告日期',
        });
        return;
      }
      this.isLoadingBaseReport = true;
      getStationBaseReport({
        StationIDstr: this.selectFormOps.StationIDstr,
        ReportDate: this.selectFormOps.ReportDate,
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res]));
          const link = document.createElement('a');
          link.href = url;
          const station = this.selectFormProject.Children.find(
            (room) => room.IdStr === this.selectFormOps.StationIDstr,
          );
          link.setAttribute(
            'download',
            `配电安全运维月报-${station.StationName}${this.selectFormOps.ReportDate}.doc`,
          ); // or any other extension
          document.body.appendChild(link);
          link.click();
          this.isLoadingBaseReport = false;
        })
        .catch(() => {
          this.isLoadingBaseReport = false;
        })
        .then(() => {
          this.isLoadingBaseReport = false;
        });
    },
    selectProjectListener(val) {
      this.selectFormProject = this.projectList.find(
        (item) => item.IdStr === val,
      );
      if (this.selectFormProject.Children) {
        [this.selectFormRoom] = this.selectFormProject.Children;
      }
    },
    selectRoomListener(val) {
      this.selectFormRoom = this.selectFormProject.Children.find(
        (item) => item.IdStr === val,
      );
    },
    // 添加、修改报告
    postForm() {
      this.selectFormOps.ProjectName = this.selectFormProject.ModelName;
      this.selectFormOps.StationName = this.selectFormRoom.ModelName;
      console.log(this.selectFormOps);
      const formData = convertDataToFormData(this.selectFormOps);
      if (this.modifyFile || this.isNew) {
        const [selectFile] = this.$refs.fileInput.$el.querySelector(
          'input',
        ).files;
        if (selectFile) {
          formData.set('FilePath', selectFile, selectFile.name);
        }
      }

      // 提交表单
      this.addModifyReport(formData).then((res) => {
        console.log('res', res);
        this.modifyFile = false;
        this.dialogVisible = false;
        if (!this.isNew) {
          this.selectOps = Object.assign(this.selectOps, this.selectFormOps);
        } else if (this.pageIndex !== 1) {
          this.pageIndex = 1;
        } else {
          this.requestOpsFiles();
        }
        console.log(this.selectOps);
      });
    },
    // 添加、修改报告
    addModifyReport(formData) {
      if (this.isNew) {
        return addOpsFile(formData).then(() => {
          this.requestOpsFiles();
        });
      }
      return modifyOpsFile(formData).then(() => {
        this.requestOpsFiles();
      });
    },
    // 更新报告
    handleModify(report) {
      this.isNew = false;
      this.diaTitle = '修改';
      this.selectOps = report;
      this.selectFormOps = {
        ...report,
        RIDstr: report.TabIDstr,
      };
      this.dialogVisible = true;
    },
    delbutton(report) {
      this.$confirm('是否确定删除该条信息？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      })
        .then(() => {
          delreport({
            RIDstr: report.TabIDstr,
          })
            .then((res) => {
              this.$message.success('删除成功');
              this.requestOpsFiles();
              console.log(res);
            })
            .catch(() => {
              this.$message.success('删除失败');
            });
        })
        .catch(() => {
        //   this.$message({
        //     type: 'info',
        //     message: action === 'cancel'
        //       ? '放弃删除并离开页面'
        //       : '停留在当前页面',
        //   });
        });
    },
    // 添加新报告
    addNew() {
      this.isNew = true;
      this.diaTitle = '添加';
      this.selectFormOps = {};
      this.selectOps = {};
      this.dialogVisible = true;
    },
    initialData() {
      let firstProject = {};
      const { selectProject } = this.$store.getters;
      if (selectProject) {
        const obj = this.projectList.find((e) => e.IdStr === selectProject);
        firstProject = obj;
      } else {
        [firstProject] = this.projectList;
      }
      this.selectFormProject = firstProject;
      this.$set(this.selectFormOps, 'ProjectIDstr', firstProject.IdStr);
      this.form.selectProjectId = firstProject.IdStr;
      this.requestOpsFiles();
    },
    requestProjectList() {
      if (this.projectList !== null) {
        this.initialData();
        return;
      }
      this.$store.dispatch('projects/projectList');
    },
    requestOpsFiles() {
      if (!this.form.selectProjectId) {
        return;
      }
      console.log('ssg', this.form.selectPeriod);
      if (this.form.selectPeriod === null) {
        this.form.selectPeriod = ['', ''];
      }
      const [start, end] = this.form.selectPeriod;
      getOpsFiles({
        ProjectIDstr: this.form.selectProjectId,
        ReportName: this.form.keys,
        StationIDstr: null,
        BeginTime: start,
        EndTime: end,
        page: this.pageIndex,
        rows: this.pageInfo.size,
      })
        .then((res) => {
          console.log(res);
          this.pageInfo.total = res.total || 0;
          this.tableData = res.list || res;
        })
        .catch(() => {
          this.tableData = [];
          this.pageInfo.total = 0;
        });
    },
    // 下载文件
    handleDownload(row) {
      window.location.href = `${BASE_URL}${row.FilePath}`;
      // window.open(`${BASE_URL}${row.FilePath}`);
    },
    onSubmit() {
      this.requestOpsFiles();
    },
  },
};
</script>

<style scoped>
.form-item-input {
  width: 150px;
}
.el-table {
  display: flex;
  flex-direction: column;
}
</style>
